"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _reactRedux = require("react-redux");

var _react = _interopRequireWildcard(require("react"));

var _reactHookForm = require("react-hook-form");

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

var _ramda = require("ramda");

var _lab = require("@mui/lab");

var _AdapterMoment = _interopRequireDefault(require("@mui/lab/AdapterMoment"));

var _material = require("@mui/material");

var _StaticDatePicker = _interopRequireDefault(require("@mui/lab/StaticDatePicker"));

var _ui = require("@alycecom/ui");

var _timezones = require("../../../../../../Shared/store/timezones/timezones.constants");

var _timezones2 = require("../../../../../../Shared/store/timezones/timezones.helpers");

var _timezones3 = require("../../../../../../Shared/store/timezones/timezones.selectors");

var _batch = require("../../../constants/batch.schemas");

var _user = require("../../../../../../Shared/store/user/user.selectors");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var styles = {
  autocomplete: {
    ["& .".concat(_material.outlinedInputClasses.root)]: {
      padding: '6.5px'
    }
  },
  autocompleteListbox: {
    minWidth: 300
  }
};

var CustomScheduleForm = function CustomScheduleForm(_ref) {
  var onCancel = _ref.onCancel,
      onSubmit = _ref.onSubmit;

  var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      timezonesSearch = _useState2[0],
      setTimezonesSearch = _useState2[1];

  var timezones = (0, _reactRedux.useSelector)(_timezones3.getTimezones);
  var userTimezone = (0, _reactRedux.useSelector)(_user.getUserTimezone);
  var timezoneOptions = (0, _react.useMemo)(function () {
    return timezones.reduce(function (options, timezone) {
      return _objectSpread(_objectSpread({}, options), {}, {
        [timezone.name]: _objectSpread(_objectSpread({}, timezone), {}, {
          optionTitle: (0, _timezones2.formatTimezoneTitle)(timezone)
        })
      });
    }, {});
  }, [timezones]);
  var today = (0, _react.useMemo)(function () {
    return (0, _momentTimezone.default)().tz('US/Eastern').add(1, 'hours').set({
      minutes: 0,
      seconds: 0
    });
  }, []);

  var _useForm = (0, _reactHookForm.useForm)({
    mode: 'all',
    resolver: _batch.customScheduleFormResolver,
    defaultValues: {
      tz: userTimezone || _timezones.DEFAULT_TIMEZONE_NAME,
      hh: 11,
      mm: 0,
      interval: 'am',
      date: today.format()
    }
  }),
      control = _useForm.control,
      handleSubmit = _useForm.handleSubmit;

  var _useController = (0, _reactHookForm.useController)({
    control,
    name: 'tz'
  }),
      _useController$field = _useController.field,
      timezoneValue = _useController$field.value,
      onTimezoneChange = _useController$field.onChange,
      timezoneErrors = _useController.fieldState.error;

  var _useController2 = (0, _reactHookForm.useController)({
    control,
    name: 'interval'
  }),
      _useController2$field = _useController2.field,
      intervalValue = _useController2$field.value,
      onIntervalChange = _useController2$field.onChange,
      intervalError = _useController2.fieldState.error;

  var _useController3 = (0, _reactHookForm.useController)({
    control,
    name: 'hh'
  }),
      _useController3$field = _useController3.field,
      hoursValue = _useController3$field.value,
      onHoursChange = _useController3$field.onChange,
      hoursError = _useController3.fieldState.error;

  var _useController4 = (0, _reactHookForm.useController)({
    control,
    name: 'date'
  }),
      _useController4$field = _useController4.field,
      dateValue = _useController4$field.value,
      onDateChange = _useController4$field.onChange;

  var _useMemo = (0, _react.useMemo)(function () {
    var timeNowPlusHour = (0, _momentTimezone.default)().tz(timezoneValue).add(1, 'hours');

    var _timeNowPlusHour$form = timeNowPlusHour.format('h a').split(' '),
        _timeNowPlusHour$form2 = (0, _slicedToArray2.default)(_timeNowPlusHour$form, 2),
        nextHours = _timeNowPlusHour$form2[0],
        nextHoursMeridien = _timeNowPlusHour$form2[1];

    return {
      minDate: timeNowPlusHour,
      endOfTheDay: (0, _momentTimezone.default)().tz(timezoneValue).set({
        hours: 23,
        minutes: 59
      }),
      todayAmHours: nextHoursMeridien === 'am' ? (0, _ramda.range)(Number(nextHours), 12) : [],
      todayPmHours: nextHoursMeridien === 'am' ? (0, _ramda.range)(1, 13) : (0, _ramda.range)(Number(nextHours), 13)
    };
  }, [timezoneValue]),
      minDate = _useMemo.minDate,
      endOfTheDay = _useMemo.endOfTheDay,
      todayAmHours = _useMemo.todayAmHours,
      todayPmHours = _useMemo.todayPmHours;

  var isToday = (0, _momentTimezone.default)(dateValue).isSameOrBefore(endOfTheDay);
  var todayHours = intervalValue === 'am' ? todayAmHours : todayPmHours;
  var hours = isToday ? todayHours : (0, _ramda.range)(1, 13);
  (0, _react.useEffect)(function () {
    if (!isToday) {
      return;
    }

    if (todayAmHours.length) {
      onIntervalChange('am');
      onHoursChange(Math.max.apply(Math, (0, _toConsumableArray2.default)(todayAmHours)));
      return;
    }

    onIntervalChange('pm');
    onHoursChange(Math.min.apply(Math, (0, _toConsumableArray2.default)(todayPmHours)));
  }, [todayAmHours, todayPmHours, onHoursChange, onIntervalChange, isToday]);
  (0, _react.useEffect)(function () {
    onTimezoneChange(userTimezone);
  }, [userTimezone, onTimezoneChange]);

  var handleSchedule = function handleSchedule(form) {
    var _moment$toArray = (0, _momentTimezone.default)(form.date).toArray(),
        _moment$toArray2 = (0, _slicedToArray2.default)(_moment$toArray, 3),
        year = _moment$toArray2[0],
        month = _moment$toArray2[1],
        day = _moment$toArray2[2];

    var time = _momentTimezone.default.tz("".concat(year, " ").concat(month + 1, " ").concat(day, " ").concat(form.hh, ":").concat(form.mm, " ").concat(form.interval), 'YYYY M D h:m A', form.tz);

    onSubmit(time.format());
  };

  return /*#__PURE__*/_react.default.createElement(_lab.LocalizationProvider, {
    dateAdapter: _AdapterMoment.default
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    minWidth: 542,
    component: "form",
    p: 3,
    display: "flex",
    flexDirection: "column",
    onSubmit: handleSubmit(handleSchedule)
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h4"
  }, "Pick Date & Time"), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 3,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_StaticDatePicker.default, {
    displayStaticWrapperAs: "desktop",
    onChange: onDateChange,
    value: dateValue,
    minDate: minDate,
    openTo: "day",
    disablePast: true,
    renderInput: function renderInput(params) {
      return /*#__PURE__*/_react.default.createElement(_material.TextField, params);
    }
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    spacing: 0.5
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    container: true,
    spacing: 0.5,
    xs: 7
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/_react.default.createElement(_material.FormControl, {
    error: !!(hoursError !== null && hoursError !== void 0 && hoursError.message),
    variant: "outlined",
    fullWidth: true
  }, /*#__PURE__*/_react.default.createElement(_material.InputLabel, {
    id: "SendGift.CustomSchedule.HoursLabel"
  }, "Hours"), /*#__PURE__*/_react.default.createElement(_material.Select, {
    labelId: "SendGift.CustomSchedule.HoursLabel",
    label: "Hours",
    onChange: onHoursChange,
    value: hoursValue,
    name: "hh"
  }, hours.map(function (hh) {
    return /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
      key: hh,
      value: hh
    }, String(hh).padStart(2, '0'));
  })), !!(hoursError !== null && hoursError !== void 0 && hoursError.message) && /*#__PURE__*/_react.default.createElement(_material.FormHelperText, null, hoursError.message))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/_react.default.createElement(_reactHookForm.Controller, {
    name: "mm",
    control: control,
    render: function render(_ref2) {
      var _ref2$field = _ref2.field,
          onChange = _ref2$field.onChange,
          value = _ref2$field.value;
      return /*#__PURE__*/_react.default.createElement(_material.FormControl, {
        variant: "outlined",
        fullWidth: true
      }, /*#__PURE__*/_react.default.createElement(_material.InputLabel, {
        id: "SendGift.CustomSchedule.MinutesLabel"
      }, "Minutes"), /*#__PURE__*/_react.default.createElement(_material.Select, {
        labelId: "SendGift.CustomSchedule.MinutesLabel",
        label: "Minutes",
        onChange: onChange,
        value: value,
        name: "mm"
      }, Array.from({
        length: 4
      }, function (_, index) {
        return /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
          key: index,
          value: index * 15
        }, String(index * 15).padStart(2, '0'));
      })));
    }
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/_react.default.createElement(_material.FormControl, {
    error: !!(intervalError !== null && intervalError !== void 0 && intervalError.message),
    variant: "outlined",
    fullWidth: true
  }, /*#__PURE__*/_react.default.createElement(_material.InputLabel, {
    id: "SendGift.CustomSchedule.PeriodLabel"
  }, "Period"), /*#__PURE__*/_react.default.createElement(_material.Select, {
    labelId: "SendGift.CustomSchedule.PeriodLabel",
    label: "Period",
    onChange: onIntervalChange,
    value: intervalValue,
    name: "interval"
  }, !(isToday && todayAmHours.length === 0) && /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
    value: "am"
  }, "AM"), /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
    value: "pm"
  }, "PM")), !!(intervalError !== null && intervalError !== void 0 && intervalError.message) && /*#__PURE__*/_react.default.createElement(_material.FormHelperText, null, intervalError.message)))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 5
  }, /*#__PURE__*/_react.default.createElement(_material.FormControl, {
    error: !!(timezoneErrors !== null && timezoneErrors !== void 0 && timezoneErrors.message)
  }, /*#__PURE__*/_react.default.createElement(_ui.Autocomplete, {
    sx: styles.autocomplete,
    ListboxProps: {
      sx: styles.autocompleteListbox
    },
    value: timezoneValue,
    options: Object.keys(timezoneOptions),
    inputValue: timezonesSearch,
    label: "Your timezone",
    clearOnBlur: true,
    getOptionLabel: function getOptionLabel(option) {
      var _timezoneOptions$opti;

      return (_timezoneOptions$opti = timezoneOptions[option]) === null || _timezoneOptions$opti === void 0 ? void 0 : _timezoneOptions$opti.optionTitle;
    },
    onChange: function onChange(_, value) {
      return value && onTimezoneChange(value);
    },
    onInputChange: function onInputChange(_, newValue) {
      return setTimezonesSearch(newValue);
    }
  }), !!(timezoneErrors !== null && timezoneErrors !== void 0 && timezoneErrors.message) && /*#__PURE__*/_react.default.createElement(_material.FormHelperText, null, timezoneErrors.message)))), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 3,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end"
  }, /*#__PURE__*/_react.default.createElement(_ui.Button, {
    onClick: onCancel
  }, "Cancel"), /*#__PURE__*/_react.default.createElement(_material.Box, {
    ml: 3
  }, /*#__PURE__*/_react.default.createElement(_ui.Button, {
    color: "secondary",
    type: "submit"
  }, "Confirm & Schedule Gifts")))));
};

var _default = CustomScheduleForm;
exports.default = _default;